const SeparaterLine = ({ height, background }) => {
    return (
        <div className="seperatorLine" style={{ height: height, background: background }}></div>
    )
}

export default SeparaterLine